import axios from "axios";

const state = {
    NewPin:'',
    ConfirmPin:'',
    OldPin:''
};

const getters = {
  getNewPin(state) {
    return state.NewPin;
  },
  getConfirmPin(state) {
    return state.ConfirmPin;
  },
  getOldPin(state) {
    return state.OldPin;
  },

};

const mutations = {

  setConfirmPin(state, payload) {
    state.ConfirmPin = payload;
  },
  setNewPin(state, payload) {
    state.NewPin = payload;
  },
  setOldPin(state, payload) {
    state.OldPin = payload;
  },
 

};

const actions = {
  
  ChangePin({commit}, payload) {
    commit("setLoading", true);
    commit("setSnackbar", false);
    axios
      .post(`https://backoffice.teller.ng/TellerAppManager/api/PinChangeRequest?customerID=${payload.customerID}&currentPin=${payload.oldPIN}&newPin=${payload.Pin}`,{},{timeout:20000})
      .then(res => {
        if(res.data.message == 'OK'){
        console.log(res.data.message)
        commit("setSnackbar", true);
        commit("setServerMessage", "Successful")
        commit('setUser', null)
        payload.route.push({name: "login"})
        }else{
          commit("setSnackbar", true);
          commit("setServerMessage", res.data.message)
        } 
      })
      .catch(err => {
        console.log(err, 'err')
        if (err.code === 'ECONNABORTED'){
          commit("setSnackbar", true);
          commit("setServerMessage",  "Server Timeout" );
          return
        }
        commit("setServerMessage",  err.message );
      })
      .finally(()=>{
        commit("setLoading", false);
      })
  },
  

};

export default {
  state,
  mutations,
  getters,
  actions
};
